import HighlightHTML from 'components/HighlightHTML/HighlightHTML';

/**
 * NoteBody component that supports searchable text with highlight.
 * DO NOT use with children. See example below
 *
 * Recommended Usage:
 * <NoteBody searchableContent={string} otherElements={JSX.Element} highlight={string} ... />
 *
 * @param {Object} props
 * @param {string} props.searchableContent - string content that is used to search upon.
 * @param {JSX} props.otherElements - One or more JSX.
 * @param {string} props.highlight- the text to hightlight within the searchable context if there is a match.
 * @returns
 */
const NoteBody = ({ searchableContent, otherElements, highlight, ...rest }) => {
  return (
    <div className="fs-mask" style={{ whiteSpace: 'pre-wrap' }} {...rest}>
      <HighlightHTML html={searchableContent} textToHighlight={highlight} />
      {otherElements}
    </div>
  );
};

export default NoteBody;
